import { render, staticRenderFns } from "./MenuOptionsChat.vue?vue&type=template&id=c74cf320&scoped=true&"
import script from "./MenuOptionsChat.vue?vue&type=script&lang=js&"
export * from "./MenuOptionsChat.vue?vue&type=script&lang=js&"
import style0 from "./MenuOptionsChat.vue?vue&type=style&index=0&id=c74cf320&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c74cf320",
  null
  
)

export default component.exports